export const DEFENDER_COLUMNS = [
  { id: 'expand', label: '', className: '', field: 'expand' },
  { id: 'agentVersion', label: 'Agent Version', className: 'minWidth-175', field: 'agentVersion' },
  { id: 'computerDnsName', label: 'Computer DNS Name', className: 'minWidth-175', field: 'computerDnsName' },
  { id: 'exposureLevel', label: 'Exposure Level', className: 'minWidth-175', field: 'exposureLevel' },
  { id: 'osPlatform', label: 'OS Platform', className: 'minWidth-175', field: 'osPlatform' },
]

export const EDR_COLUMNS = [
  { id: 'expand', label: '', className: '', field: 'expand' },
  { id: 'accountId', label: 'Account ID', className: 'minWidth-175', field: 'accountId' },
  { id: 'computerName', label: 'Computer Name', className: 'minWidth-175', field: 'computerName' },
  { id: 'osPlatform', label: 'OS Platform', className: 'minWidth-175', field: 'osName' },
  { id: 'domain', label: 'Domain', className: 'minWidth-175', field: 'domain' },
]

export const COVE_COLUMNS = [
  { id: 'expand', label: '', className: '', field: 'expand' },
  { id: 'CreationTime', label: 'Creation Time', className: 'minWidth-175', field: 'CreationTime', isDate: false },
  { id: 'Name', label: ' Name', className: 'minWidth-175', field: 'Name' },
  { id: 'Type', label: 'Type', className: 'minWidth-175', field: 'Type' },
]
export const PATCH_COLUMNS = [
  { id: 'expand', label: '', className: '', field: 'expand' },
  { id: 'clientName', label: 'Client Name', className: 'minWidth-175', field: 'clientName' },
  { id: 'type', label: 'Type', className: 'minWidth-175', field: 'type' },
  { id: 'username', label: 'Username', className: 'minWidth-175', field: 'username' },
]
